import _ from 'lodash';
import { fork, call, put, select, takeEvery } from 'redux-saga/effects';

import {
    GET_DIRECTORS,
    fetchDirectors,
    directorsFetchSucceed,
    directorsFetchFailed
} from './AutoDirectors.actions';
import { isLimitedCompany } from '../../../helpers/helpers';
import { getApplicationState } from '../../../sagas';
import { fetchAssociatedPeople, getStateKey } from '../../../utils/Api';

export function* getCompanyDirectors() {
    const { fetching, success } = yield select((state) => {
        return state.fetched.directors;
    });
    if (fetching || _.isBoolean(success)) {
        return;
    }

    yield put(fetchDirectors());
    const applicationState = yield* getApplicationState();
    if (!isLimitedCompany(applicationState)) {
        yield put(directorsFetchSucceed([]));
    }

    try {
        const associatedPeople = yield call(
            fetchAssociatedPeople,
            getStateKey()
        );
        const directors = associatedPeople.filter((person) =>
            _.includes(person.roles, 'director')
        );
        yield put(directorsFetchSucceed(directors));
    } catch (e) {
        yield put(directorsFetchFailed());
    }
}

function* takeCompanyDirectors() {
    yield takeEvery(GET_DIRECTORS, getCompanyDirectors);
}

export default [fork(takeCompanyDirectors)];
